import { Toast } from 'vant'
import openView from '@/common/open-view'
import { openWeb } from '@/common'
/* eslint-disable @typescript-eslint/no-var-requires */
export function getHtmlFontPX() {
  const fontSize = document.querySelector('html')?.style.fontSize
  const num = Number(fontSize?.substring(0, fontSize.indexOf('px')))
  console.log(fontSize?.substring(0, fontSize.indexOf('px')))
  return num
}
export function isValidKey(key: string, obj: { [propName: string]: any }) {
  return key in obj
}
export function addition(res: any) {
  console.log('驳回情况')

  //驳回情况：身份证正面、反面、大头像、交易密码、资金密码、三方存管、转户驳回到视频见证
  const photoParam = {
    needFront: res.needPhotoFront != undefined ? res.needPhotoFront : '0',
    needBack: res.needPhotoBack != undefined ? res.needPhotoBack : '0',
  }
  const pwdParam = {
    needBusinessPwd: res.needBusinessPassword != undefined ? res.needBusinessPassword : '0',
    needFundPwd: res.needFundPassword != undefined ? res.needFundPassword : '0',
  }
  const videoParam = {
    needVideo: res.needVideo != undefined ? res.needVideo : '0',
  }
  const thirdParam = {
    needThirdDeposit: res.needThirdDeposit != undefined ? res.needThirdDeposit : '0',
  }
  const accountParam = {
    needAccount: res.needAccount != undefined ? res.needAccount : '0',
  }
  const selfVideoParam = {
    self_step: res.backStep != undefined ? res.backStep : '0',
    self_first_state: res.firstState != undefined ? res.firstState : '0',
    needFirstId: res.needFirstId != undefined ? res.needFirstId : '0',
    needFirstVideo: res.needFirstVideo != undefined ? res.needFirstVideo : '0',
    needFirstReason: res.needFirstReason != undefined ? res.needFirstReason : '0',
    needNohat: res.needPhotoNohat != undefined ? res.needPhotoNohat : '0',
  }
  // stora
  setSStorageInfo('videoParam', JSON.stringify(videoParam))
  setSStorageInfo('pwdParam', JSON.stringify(pwdParam))
  setSStorageInfo('thirdParam', JSON.stringify(thirdParam))
  setSStorageInfo('accountParam', JSON.stringify(accountParam))
  setSStorageInfo('selfVideoParam', JSON.stringify(selfVideoParam))
  clearSStorage('accountInfo')
  setSStorageInfo('accountInfo', JSON.stringify(res))
  // 1.补全照片
  if (photoParam['needFront'] == 1 || photoParam['needBack'] == 1) {
    openView('uploadPhoto', { isBack: true, ...photoParam })
    return true
  }

  // 2.驳回开立账户
  if (accountParam['needAccount'] == 1) {
    openView('accountSetting', { isBack: true, ...accountParam })
    return true
  }
  // 3.驳回密码设置
  // if (pwdParam['needBusinessPwd'] == 1 || pwdParam['needFundPwd'] == 1) {
  //   openView('accountSetting', { isBack: true, ...pwdParam })
  //   return true
  // }
  // 4.驳回三方存管
  if (thirdParam['needThirdDeposit'] == 1) {
    openView('bind-bank', { isBack: true, ...thirdParam })
    return true
  }
  // 5.驳回视频见证
  if (videoParam['needVideo'] == 1) {
    // if (getSStorageInfo("current_witness_way") == "1") {  // 单向视频 复核状态驳回视频
    openView('video-auth', { isBack: true, ...videoParam })
    return true
  }
  if (selfVideoParam['needNohat'] == 1) {
    openView('video-auth', { isBack: true, ...selfVideoParam })
    return true
  }
  //6. 单向视频
  if (selfVideoParam['self_step'] == '1' && selfVideoParam['self_first_state'] == '2') {
    //初审状态驳回身份证、视频
    if (selfVideoParam['needFirstId'] == '1') {
      openView('uploadPhoto', {
        isBack: true,
        photo_type: 'photo_again',
        isVideoBack: '1',
        ...selfVideoParam,
      })
      return true
    } else if (selfVideoParam['needFirstVideo'] == '1') {
      //pageInit("account/msgVerify", "account/videoNotice");
      openView('video-auth', { isBack: true, ...selfVideoParam })
      return true
    } else {
      return false
    }
  } else {
    return false
  }
}
export function setSStorageInfo(key: any, value: any) {
  value = null != value ? value : ''
  const aes = require('../api/aes')
  if (aes)
    try {
      const keyHex = aes.enc.Utf8.parse('iloveyou'),
        valueHex = aes.enc.Utf8.parse(value),
        iv = aes.enc.Utf8.parse('iloveyou'),
        encrypted = aes.AES.encrypt(valueHex, keyHex, {
          iv: iv,
          mode: aes.mode.CBC,
        })
      value = encrypted.toString()
    } catch (e) {
      Toast('setSStorageInfo：保存数据时，加密失败！')
    }
  try {
    sessionStorage.setItem(key, value)
  } catch (e) {
    Toast(
      '您的浏览器版本太低，或者您开启了隐身/无痕浏览模式，或者WebView组件不支持sessionStorage！'
    )
  }
}

export function getSStorageInfo(key: any) {
  let value = null
  try {
    value = sessionStorage.getItem(key)
  } catch (e) {
    Toast(
      '您的浏览器版本太低，或者您开启了隐身/无痕浏览模式，或者WebView组件不支持sessionStorage！'
    )
  }
  value = null != value ? value : ''
  const aes = require('../api/aes')
  if (aes)
    try {
      const keyHex = aes.enc.Utf8.parse('iloveyou'),
        iv = aes.enc.Utf8.parse('iloveyou'),
        valueHex = aes.enc.Base64.parse(value),
        decrypted = aes.AES.decrypt(
          {
            ciphertext: valueHex,
          },
          keyHex,
          {
            iv: iv,
            mode: aes.mode.CBC,
          }
        )

      value = decrypted.toString(aes.enc.Utf8)
      // console.log(value)
    } catch (e) {
      Toast('getSStorageInfo：取数据时，解密失败！')
    }
  return value ? value : null
}
export function clearSStorage(key: any) {
  try {
    if (key === !0) sessionStorage.clear()
    else if (key) sessionStorage.removeItem(key)
  } catch (e) {
    Toast(
      '您的浏览器版本太低，或者您开启了隐身/无痕浏览模式，或者WebView组件不支持sessionStorage！'
    )
  }
}
export function rsaEncrypt(a: any, b: any, c: any) {
  const endecryptUtils = require('../api/endecryptUtils')
  return endecryptUtils.rsaEncrypt(a, b, c)
}

/**
 * 获取公共参数
 * @returns
 */
export function getCommonParam() {
  let result = `?requestId=${getUuid()}&deviceType=H5`
  let cparam = getSStorageInfo('cParam')
  if (!cparam) {
    return result
  } else {
    cparam = JSON.parse(cparam)
    const mobilephone = cparam.mobilephone ? cparam.mobilephone : ''
    const userId = cparam.userId ? cparam.userId : ''
    const token = cparam.token ? cparam.token : ''
    const loginMobile = cparam.mobilephone ? cparam.mobilephone : '' //用于上传文件接口
    if (loginMobile) {
      result = result + `&loginMobile=${loginMobile}`
    }
    if (mobilephone) {
      result = result + `&mobilephone=${mobilephone}`
    }
    if (userId) {
      result = result + `&userId=${userId}`
    }
    if (token) {
      result = result + `&token=${token}`
    }
    return result
  }
}

/**
 *
 * @returns 返回唯一id，用于请求requestId
 */
export function getUuid() {
  const s: any = []
  const hexDigits = '0123456789abcdef'
  for (let i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
  }
  s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = '-'

  const uuid = s.join('')
  return uuid
}

/**
 * json转化form
 * @param params
 * @returns
 */
export const formdataify = (params: any) => {
  const formData = new FormData()
  Object.keys(params).forEach(key => {
    console.log(key, params[key])
    if (key == 'file') {
      formData.append(key, params[key])
    } else {
      formData.append(key, params[key], params[key].name)
    }
  })
  return formData
}

// 获取下一步页面
export function nextStep() {
  return getStepInfo(false)
}

// 获取下一步页面名称
export function nextStepName() {
  return getStepInfo(true)
}

function getStepInfo(hasName: boolean) {
  let step = ''
  let name = ''
  const path = ''

  const pageFlag = getSStorageInfo('pageFlag') ? JSON.parse(getSStorageInfo('pageFlag')) : {}
  if (Object.keys(pageFlag).length === 0) {
    return false
  }
  console.log('pageFlag---', pageFlag)

  // 步骤flag
  if (pageFlag.uploadimgFlag != '1') {
    // 上传身份证
    step = path + 'uploadPhoto'
    name = '信息确认'
  } else if (pageFlag.idconfirmFlag != '1') {
    // 身份证确认
    step = path + 'personInfo'
    name = '信息确认'
  } else if (pageFlag.branchFlag != '1') {
    // 选择营业部
    step = path + 'personInfo'
    name = '信息确认'
  } else if (pageFlag.signprotocolFlag != '1') {
    // 协议签署
    step = path + 'personInfo'
    name = '信息确认'
  } else if (pageFlag.risksurveyFlag != '1') {
    // 风险测评
    step = path + 'riskCheck'
    name = '风险测评'
  } else if (pageFlag.stkacctFlag != '1') {
    // 账户设置
    step = path + 'accountSetting'
    name = '账户设置'
  } else if (pageFlag.setpwdFlag != '1') {
    // 设置交易密码
    step = path + 'accountSetting'
    name = '设置交易密码'
  } else if (pageFlag.tpbankFlag != '1') {
    // 绑定三方存管
    step = path + 'bind-bank'
    name = '绑定三方存管'
  } else if (pageFlag.witnessFlag != '1') {
    // 视频见证
    step = path + 'video-auth'
    name = '视频见证'
  } else if (pageFlag.visitsurveyFlag != '1') {
    // 问卷回访
    step = path + 'return-visitor' //单双向视频都要问卷回访
    name = '问卷回访'
  } else {
    step = path + 'result' //开户完成页面
    name = '提交结果'
  }
  if (hasName) {
    return name
  } else {
    return step
  }
}

/**
 *
 * @desc 判断是否为空引用类型
 * @param {*} obj
 * @return {*}
 */
export function isEmptyObj(obj: any = []) {
  return obj ? Object.keys(obj).length === 0 : true
}

function strToInt(strValue: string) {
  while (strValue.length > 1 && strValue.substring(0, 1) == '0') {
    strValue = strValue.substring(1, strValue.length)
  }
  return parseInt(strValue)
}
/**
 * 执行正则表达式
 * @param pattern 校验的正则表达式
 * @param strValue 校验的值
 * @returns {boolean}
 */
function executeExp(pattern: RegExp, strValue: string) {
  return pattern.test(strValue)
}
/**
 * 判断字符串是否为空
 * @param strValue 校验的值
 * @returns {boolean}
 */
function isEmpty(strValue: string) {
  strValue = strValue.trim()
  return strValue.length == 0
}

/**
 * 判断是否是数字
 * @param strValue
 * @returns
 */
export function isNumeric(strValue: string) {
  if (isEmpty(strValue)) return false
  const pattern = /^[0-9]*$/
  return executeExp(pattern, strValue)
}
/**
 * 判断是否手机号或座机
 * @param strValue
 * @returns
 */
export function phoneValidator(value: string) {
  const mobile = /^1(3|4|5|6|7|8|9)\d{9}$/ //手机正则
  const tel = /^(0\d{2,3}-){0,1}\d{7,8}$/ //固话：区号(3-4位)-号码(7-9位)
  //澳门电话号码: 28开头，后面跟6位数字，区号为853
  const macaoMobReg = /^(853)?28\d{6}$/
  //澳门手机号码：6开头，后面跟7位数字，区号为853
  const macaoPhoneReg = /^(853)?6\d{7}$/
  if (
    mobile.test(value) ||
    tel.test(value) ||
    macaoMobReg.test(value) ||
    macaoPhoneReg.test(value)
  ) {
    return true
  } else {
    return false
  }
}
/**
 * 根据身份证获取生日，不包含-
 * @param idCard
 * @returns
 */
export function getBirthday(idCard: string) {
  let birthdayStr
  if (15 == idCard.length) {
    birthdayStr = idCard.charAt(6) + idCard.charAt(7)
    if (parseInt(birthdayStr) < 10) {
      birthdayStr = '20' + birthdayStr
    } else {
      birthdayStr = '19' + birthdayStr
    }
    birthdayStr =
      birthdayStr + idCard.charAt(8) + idCard.charAt(9) + idCard.charAt(10) + idCard.charAt(11)
  } else if (18 == idCard.length) {
    birthdayStr =
      idCard.charAt(6) +
      idCard.charAt(7) +
      idCard.charAt(8) +
      idCard.charAt(9) +
      idCard.charAt(10) +
      idCard.charAt(11) +
      idCard.charAt(12) +
      idCard.charAt(13)
  }
  return birthdayStr
}

/**
 * 根据身份证获取生日，包含-
 * @param idCard
 * @returns
 */
export function getBirthdayByIdno(idCard: string) {
  let birthdayStr
  if (15 == idCard.length) {
    birthdayStr = idCard.charAt(6) + idCard.charAt(7)
    if (parseInt(birthdayStr) < 10) {
      birthdayStr = '20' + birthdayStr
    } else {
      birthdayStr = '19' + birthdayStr
    }
    birthdayStr =
      birthdayStr +
      '-' +
      idCard.charAt(8) +
      idCard.charAt(9) +
      '-' +
      idCard.charAt(10) +
      idCard.charAt(11)
  } else if (18 == idCard.length) {
    birthdayStr =
      idCard.charAt(6) +
      idCard.charAt(7) +
      idCard.charAt(8) +
      idCard.charAt(9) +
      '-' +
      idCard.charAt(10) +
      idCard.charAt(11) +
      '-' +
      idCard.charAt(12) +
      idCard.charAt(13)
  }
  return birthdayStr
}
/**
 * 判断是否为邮政编码
 * @param strValue 校验的值
 * @returns {boolean}
 */
export function isPostalCode(strValue: string) {
  if (isEmpty(strValue)) return false
  const pattern = /(^\d{6}$)/
  return executeExp(pattern, strValue)
}

/**
 * 判断是否是身份证
 * @param strValue
 * @returns
 */
export function isCardID(strValue: string) {
  if (isEmpty(strValue)) {
    return false
  }
  strValue = strValue.toUpperCase()
  const vcity: any = {
    11: '北京',
    12: '天津',
    13: '河北',
    14: '山西',
    15: '内蒙古',
    21: '辽宁',
    22: '吉林',
    23: '黑龙江',
    31: '上海',
    32: '江苏',
    33: '浙江',
    34: '安徽',
    35: '福建',
    36: '江西',
    37: '山东',
    41: '河南',
    42: '湖北',
    43: '湖南',
    44: '广东',
    45: '广西',
    46: '海南',
    50: '重庆',
    51: '四川',
    52: '贵州',
    53: '云南',
    54: '西藏',
    61: '陕西',
    62: '甘肃',
    63: '青海',
    64: '宁夏',
    65: '新疆',
    71: '台湾',
    81: '香港',
    82: '澳门',
    91: '国外',
  }
  //校验长度，类型,18位，18位前17位为数字，最后一位是校验位，可能为数字或字符X
  const pattern = /(^\d{17}(\d|X)$)/
  if (executeExp(pattern, strValue) === false) {
    return false
  }
  //检查省份
  const province = strValue.substr(0, 2)
  if (vcity[province] == undefined) {
    return false
  }
  //校验生日
  const len = strValue.length
  //身份证15位时，次序为省（3位）市（3位）年（2位）月（2位）日（2位）校验位（3位），皆为数字

  //身份证18位时，次序为省（3位）市（3位）年（4位）月（2位）日（2位）校验位（4位），校验位末尾可能为X
  if (len == 18) {
    const re_eighteen = /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/
    const arr_data: any = strValue.match(re_eighteen)
    const year = strToInt(arr_data[2])
    const month = strToInt(arr_data[3])
    const day = strToInt(arr_data[4])
    const birthday = new Date(year + '/' + month + '/' + day)
    //var birthday = new Date();
    birthday.setFullYear(year)
    birthday.setMonth(month - 1)
    birthday.setDate(day)
    const now = new Date()
    const now_year = now.getFullYear()
    //年月日是否合理
    if (
      birthday.getFullYear() == year &&
      birthday.getMonth() + 1 == month &&
      birthday.getDate() == day
    ) {
      //判断年份的范围（3岁到100岁之间)
      const time = now_year - year
      if (!(time >= 3 && time <= 100)) {
        return false
      }
    } else {
      return false
    }
  }
  //检验位的检测
  if (strValue.length == 18) {
    const arrInt = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
    const arrCh = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2']
    let cardTemp = 0,
      i

    for (i = 0; i < 17; i++) {
      cardTemp += parseInt(strValue.substr(i, 1)) * arrInt[i]
    }
    const valnum = arrCh[cardTemp % 11]
    if (!(valnum == strValue.substr(17, 1))) {
      return false
    }
  }
  return true
}

/**
 * 互斥对象拍平
 * @param list 数组
 * @returns {boolean}
 */
export function formatMax(list: any) {
  const obj: any = {}
  list.forEach((i: any) => {
    i.item.split(',').forEach((j: any) => {
      if (obj[i.key] !== undefined) {
        obj[i.key].push({
          id: j,
          desc: i.desc,
        })
      } else {
        obj[i.key] = [
          {
            id: j,
            desc: i.desc,
          },
        ]
      }

      if (obj[j] !== undefined) {
        obj[j].push({
          id: i.key,
          desc: i.desc,
        })
      } else {
        obj[j] = [
          {
            id: i.key,
            desc: i.desc,
          },
        ]
      }
    })
  })
  return obj
}

// 映射index-A..
export function changQuestionBgNum(num: number) {
  let bgNum = 'A'
  switch (num) {
    case 0:
      bgNum = 'A'
      break
    case 1:
      bgNum = 'B'
      break
    case 2:
      bgNum = 'C'
      break
    case 3:
      bgNum = 'D'
      break
    case 4:
      bgNum = 'E'
      break
    case 5:
      bgNum = 'F'
      break
    case 6:
      bgNum = 'G'
      break
    default:
      bgNum = '其它'
  }
  return bgNum
}

/**
 * 判断是否为中文、英文、字母或_
 * @param strValue 校验的值
 * @returns {boolean}
 */
export function isCnAndEnNumeric(strValue: string) {
  const pattern = /^[_0-9a-zA-Z\u4e00-\u9fa5]+$/
  return executeExp(pattern, strValue)
}

/**
 * 判断是否为中文
 * @param strValue 校验的值
 * @returns {boolean}
 */
export function isCnAndEn(strValue: string) {
  if (isEmpty(strValue)) return false

  const pattern = /^[·\u4E00-\u9FA5]+$/

  return executeExp(pattern, strValue)
}

/**
 * 获取当前时间年龄，生日当天减一岁
 * @param birthday
 * @returns
 */
export function ageController(birthday: string): number {
  // 年龄控制
  const now = new Date()
  const year = now.getFullYear()
  const month = now.getMonth() + 1
  const date = now.getDate()
  const birthYear = Number(birthday.substring(0, 4))
  const birthMonth = Number(birthday.substring(5, 2))
  const birthDate = Number(birthday.substring(8, 2))
  let userAge = Number(year - birthYear)
  if (month < birthMonth || (month == birthMonth && date < birthDate)) {
    userAge--
  }
  return userAge
}

export function heightToTop(ele: any) {
  //ele为指定跳转到该位置的DOM节点
  const root = document.body
  let height = 0
  do {
    height += ele.offsetTop
    ele = ele.offsetParent
  } while (ele !== root)
  return height
}

/**
 * 滚动到el位置
 * @param el
 */
export function scroolTolEL(el: any) {
  const a: any = document.querySelector('.page-container')
  a.scrollTop = el?.offsetTop - 110 > 0 ? el?.offsetTop - 110 : 0
}

/**
 * 删除空值key
 * @param obj
 */
export function deleteObjKey(obj: any) {
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      if (!obj[key]) {
        delete obj[key]
      }
    }
  }
}

export function getRandomUniqueElement(array: any) {
  if (array.length === 0) {
    return // 如果数组为空，则返回 undefined 或其它适当的值
  }

  const randomIndex = Math.floor(Math.random() * array.length)
  const randomElement = array[randomIndex]

  // 移除已获取的元素，以确保不会重复获取
  array.splice(randomIndex, 1)

  return randomElement
}

// 视频时长转化 7s->0:07
export function formatDuration(duration: number) {
  const num = Math.floor(duration)
  const minutes = Math.floor(num / 60) < 10 ? '0' + Math.floor(num / 60) : Math.floor(num / 60)
  const seconds = Math.floor(num % 60) < 10 ? '0' + Math.floor(num % 60) : Math.floor(num % 60)
  return minutes + ':' + seconds
}
//时间格式化
export function dateFormat(oDate: string) {
  const nDate = oDate != '' ? new Date(oDate) : new Date()
  const ymd =
    nDate.getFullYear() +
    '-' +
    (nDate.getMonth() + 1 >= 10 ? nDate.getMonth() + 1 : '0' + (nDate.getMonth() + 1)) +
    '-' +
    (nDate.getDate() >= 10 ? nDate.getDate() : '0' + nDate.getDate())
  return ymd
}
//获取iframe嵌套父页面地址的id
// export function getSinaParentId() {
//   const splitParentUrl = window.parent.location.href.split('/')
//   console.log('父页面url', window.parent.location)
//   console.log('父页面url中携带的课程id',splitParentUrl.pop())
//   return splitParentUrl.pop()
// }
export function getUserInfo() {
  const userInfo = sessionStorage.getItem('userInfo') ?? ''
  if (userInfo) {
    return JSON.parse(userInfo as string)
  }
  openWeb('login.html', '')
}
